const KEY = 'helpdesk-reporter-name';

/** Der Name aus der letzten Schnellmeldung (F22). Nur für das eigene Gerät, sonst steht er unbeachtet in der Meldung der nächsten Person. */
export function rememberedName(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function rememberName(name: string): void {
  try {
    localStorage.setItem(KEY, name);
  } catch {
    /* privater Modus */
  }
}

export function forgetName(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* privater Modus */
  }
}
